import {PicMessage, TextMessage, UrlMessage, VideoMessage} from "@/pages/moments/message";

export enum MomentsStatus {
    NO_SEND = 0,
    SEND = 1,
}

export enum ContentType {
    TEXT = 1,
    IMAGE = 2,
    LINK = 3,
    VIDEO = 6,
    RADAR = 8,
}

export const momentsStatusList = [
    { key: MomentsStatus.NO_SEND, title: "未发布" },
    { key: MomentsStatus.SEND, title: "已发布" },
];

export const COMPONENTS = {
    [ContentType.TEXT]: TextMessage,
    [ContentType.IMAGE]: PicMessage,
    [ContentType.LINK]: UrlMessage,
    [ContentType.VIDEO]: VideoMessage,
    [ContentType.RADAR]: UrlMessage,
};

export type StatusAnalysis = Record<MomentsStatus, number>;

export const defaultAnalysis: StatusAnalysis = {
    [MomentsStatus.NO_SEND]: 0,
    [MomentsStatus.SEND]: 0,
};
